__turbopack_context__.v({
  "Footer4": "footer4-module__KJNFBG__Footer4",
  "Footer4Sec": "footer4-module__KJNFBG__Footer4Sec",
  "FooterMainDiv": "footer4-module__KJNFBG__FooterMainDiv",
  "FooterMainDiv1": "footer4-module__KJNFBG__FooterMainDiv1",
  "FooterMainDiv2": "footer4-module__KJNFBG__FooterMainDiv2",
  "Hr": "footer4-module__KJNFBG__Hr",
  "tinyFooter2": "footer4-module__KJNFBG__tinyFooter2",
});
